import { render } from "./KpiCategories.vue?vue&type=template&id=1ec270a8&scoped=true"
import script from "./KpiCategories.vue?vue&type=script&lang=js"
export * from "./KpiCategories.vue?vue&type=script&lang=js"

import "./KpiCategories.vue?vue&type=style&index=0&id=1ec270a8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ec270a8"]])

export default __exports__